import ReactMarkdown from "react-markdown";
import { IModalWidnow } from "../../../interfaces/quiz-content.interface";
import { PopupWindow } from "../popup-window/popup-window";
import { Button } from "../../common/button/button";
import { Fragment, useCallback, useContext } from "react";
import { StylesContext } from "../../../contexts/styles-context/styles.context";
import styles from "./custom-modal.module.scss";

interface ICustomModalProps {
  active: boolean;
  onClose?: () => void;
  modalWindow: IModalWidnow;
}

export function CustomModal({ active, modalWindow, onClose, children }: React.PropsWithChildren<ICustomModalProps>) {
  const { styles: { allButtons = {}, primaryButtons = {} } } = useContext(StylesContext);
  const { header, buttonText, buttonLink, buttonActions } = modalWindow;

  const clickHandler = useCallback(() => {
    if (buttonActions instanceof Array) buttonActions.forEach(action => {
      switch(action) {
        case "url": 
          window.open(buttonLink, "_blank");
          break;
        case "close_modal":
          onClose && onClose();
          break;
      }
    });
  }, [buttonActions, onClose]);
  
  return <PopupWindow active={active} onClose={onClose}>
  <div className={styles.container}>
    <h2 className={styles.header}>
      <ReactMarkdown
        source={ header }
        escapeHtml={false}
        renderers={{ paragraph: props => <Fragment children={props.children} /> }}
      />
    </h2>
    {children}
    <Button customStyles={{ ...allButtons, ...primaryButtons}} value={buttonText} mode="confirm" onClick={clickHandler}/>
  </div>
</PopupWindow>
}